export default "__VITE_ASSET__CYls6TTi__"